import { useEffect, useState } from 'react';
import {
  BASE_ROUTE,
  KINDS_NOT_ALLOWED_IN_ALL_TAB,
  KINDS_NOT_ALLOWED_IN_OWNED_TAB,
} from '../constants';
import { useAllKinds } from '@mb.io/core-components';
import { useLocation } from 'react-router-dom';

export const useAllowedEntityKinds = () => {
  const { allKinds } = useAllKinds();
  const [allowedKinds, setAllowedKinds] = useState<string[]>([]);
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
    const updateSelectedKinds = (kinds: string[]) => {
      setAllowedKinds(kinds);
    };

    const updateAllowedKinds = () => {
      setAllowedKinds(allKinds);
    };

    if (!allKinds.length) {
      return;
    }

    if (pathname === `${BASE_ROUTE}/all`) {
      const filteredKinds = allKinds.filter(
        (value: any) => !KINDS_NOT_ALLOWED_IN_ALL_TAB.includes(value),
      );
      updateSelectedKinds(filteredKinds);
    } else if (pathname === `${BASE_ROUTE}/owned`) {
      const filteredKinds = allKinds.filter(
        value => !KINDS_NOT_ALLOWED_IN_OWNED_TAB.includes(value),
      );
      updateSelectedKinds(filteredKinds);
    } else {
      updateAllowedKinds();
    }
  }, [allKinds, pathname]);

  return { allKinds, allowedKinds };
};
